/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStaffBrandDetails} from '../api'

 export const useQueryGetStaffBrandDetails = createReactQueryHook('getStaffBrandDetails', getStaffBrandDetails)
